// Global
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Upload } from 'antd';

// Components
import { StyledFileName, StyledPhotoInfo } from './CreateCategoryPhotoFieldStyles';
import { FormItem } from '@/components';
import { UploadIcon } from '@/icons';
import { Button } from '@/ui';

// Helpers
import { IMAGE_MIME_TYPES } from '@/constants/files';
import { CreateCategoryFieldNames } from '../../helpers/types';
import { validateCategoryImage } from '../../helpers/validateCategoryImage';

const CreateCategoryPhotoField = () => {
  const { t } = useTranslation(['categories']);

  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  return (
    <div>
      <FormItem
        name={CreateCategoryFieldNames.PHOTO}
        valuePropName={CreateCategoryFieldNames.PHOTO}
        label={t('category_photo')}
      >
        <Upload.Dragger
          maxCount={1}
          accept={IMAGE_MIME_TYPES}
          customRequest={(info) => setUploadedFile(info.file as File)}
          showUploadList={false}
          beforeUpload={(file) => validateCategoryImage(file, t)}
        >
          <UploadIcon style={{ height: '1rem', width: '100%' }} />
          <p className="ant-upload-text">{t('create_category_upload_file')}</p>
          <p className="ant-upload-hint">{t('create_category_drag_and_drop_here')}</p>
          <Button>{t('create_category_select_file_from_pc')}</Button>
          {uploadedFile && <StyledFileName>{uploadedFile.name}</StyledFileName>}
        </Upload.Dragger>
      </FormItem>
      <StyledPhotoInfo>{t('recommended_category_photo_size')}</StyledPhotoInfo>
    </div>
  );
};

export default CreateCategoryPhotoField;
